import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { ContactInfoCreationRequestDto, ContactInfoCreationResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  contactId: number;
  dto: ContactInfoCreationRequestDto;
  userId: string;
};

type Return = {
  addCustomerContactInfo: (req: Req) => Promise<ContactInfoCreationResponseDto>;
  isAdding: boolean;
};

export const useAddCustomerContactInfo = (): Return => {
  const { contactsApi } = useApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<ContactInfoCreationResponseDto, Return, Req>({
    mutationFn: async req => {
      const { data } = await contactsApi.addContactInfo(req.userId, req.contactId, req.dto);
      return data;
    },
    onSuccess: async (_data, req) => {
      await queryClient.refetchQueries({
        queryKey: [QueryKeyEnum.CONTACTS.DETAILS, req.contactId],
      });
    },
  });

  return {
    addCustomerContactInfo: mutateAsync,
    isAdding: isPending,
  };
};
